import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const customizePagesApi = createApi({
  reducerPath: "customize-pages",
  tagTypes: ["CustomizePages"],
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
    getCustomizePages: builder.query({
      query: ({ page, limit, sortBy, sortOrder }) => ({
        url: "admin/marketing-pages",
        method: "GET",
        params: { page, limit, sortBy, sortOrder },
      }),
      transformResponse: (res) => res,
      providesTags: ["CustomizePages"],
    }),

    getCustomizePageBySlug: builder.query({
      query: ({ slug }) => ({
        url: `admin/marketing-page/${slug}`,
        method: "GET",
      }),
      transformResponse: (res) => res,
      providesTags: ["CustomizePages"],
    }),

    addCustomizePage: builder.mutation({
      query: ({ data }) => ({
        url: "admin/marketing-page/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CustomizePages"],
    }),

    updateCustomizePageSection: builder.mutation({
      query: ({ slug, data }) => ({
        url: `admin/marketing-page/${slug}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["CustomizePages"],
    }),

    deleteCustomizePage: builder.mutation({
      query: ({ slug }) => ({
        url: `admin/marketing-page/${slug}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CustomizePages"],
    }),
  }),
});

export const {
  useGetCustomizePagesQuery,
  useGetCustomizePageBySlugQuery,
  useAddCustomizePageMutation,
  useUpdateCustomizePageSectionMutation,
  useDeleteCustomizePageMutation,
} = customizePagesApi;
